import { I18n } from '@/services/i18n';

type Message = {
  cancelled: string;
  wouldYouLikeToTakeCancelled: string;
  reactivate: string;
  premiumStillActive: string;
};

const messages: I18n<Message> = {
  en: {
    cancelled: 'Your {tier} membership is cancelled',
    wouldYouLikeToTakeCancelled:
      'Would you like to take care of it and reactivate now to keep using the platform?',
    reactivate: 'reactivate',
    premiumStillActive:
      'Please note that you still have access to all premium features until {date}, so feel free to use the service.',
  },
  es: {
    cancelled: 'Tu membresía {tier} está cancelada',
    wouldYouLikeToTakeCancelled:
      '¿Te gustaría encargarte de esto y reactivar ahora para seguir usando la plataforma?',
    reactivate: 'reactivar',
    premiumStillActive:
      'Ten en cuenta que aún tienes acceso a todas las características premium hasta {date}, así que siéntete libre de usar el servicio.',
  },
  de: {
    cancelled: 'Ihre {tier} Mitgliedschaft ist gekündigt',
    wouldYouLikeToTakeCancelled:
      'Möchten Sie es jetzt erledigen und jetzt reaktivieren, um die Plattform weiterhin nutzen zu können?',
    reactivate: 'reaktivieren',
    premiumStillActive:
      'Bitte beachten Sie, dass Sie weiterhin Zugriff auf alle Premium-Funktionen haben bis {date}, nutzen Sie den Dienst also gerne weiter.',
  },
};

export { messages };
